export const endpoints = {
  MAINURL: 'https://hcm.evonsys.com/prweb/api/atsapi/v1/',
  VALIDATEAPPLICANT: 'ValidateApplicant',
  APPLICANTAVAILABLESLOTS: 'ApplicantAvailableSlots',
}
